import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=bd0c0d4e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=bd0c0d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0c0d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd0c0d4e')) {
      api.createRecord('bd0c0d4e', component.options)
    } else {
      api.reload('bd0c0d4e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=bd0c0d4e&scoped=true&", function () {
      api.rerender('bd0c0d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AJLJdN0bSk2L/JS/comp/CookieBox.vue"
export default component.exports